import React, { useState, useEffect } from "react";
import { Box, IconButton, Paper } from "@mui/material";
import { Delete as DeleteIcon, Edit as EditIcon } from "@mui/icons-material";
import {
  Header,
  Section,
  Label,
  Input,
  TextArea,
  SelectComponent,
  Checklist,
  RadioButton,
  ButtonComponent,
  DividerComponent,
  FormHeader,
  Cells,
  Image,
} from "./elements";

const FormComponent = ({ component, isSelected, onUpdate, onDelete, mode, value, onChange, readOnly }) => {
  console.log("Mode", mode);
  const [isEditing, setIsEditing] = useState(false);
  const [isEditingLabel, setIsEditingLabel] = useState(false);
  const [labelValue, setLabelValue] = useState(component.label || "");

  const [isEditingHospital, setIsEditingHospital] = useState(false);
  const [isEditingTitle, setIsEditingTitle] = useState(false);
  const [logoPreview, setLogoPreview] = useState(component.logo || null);
  const fileInputRef = React.useRef();
  const [nameLogo, setNameLogo] = useState(component.nameLogo || "Nombre del hospital");
  const [titleName, setTitleName] = useState(component.titleName || "Nuevo Formulario");

  // Sincronizar estados locales con las props cuando cambian desde fuera (panel de propiedades)
  useEffect(() => {
    if (component.nameLogo !== undefined && component.nameLogo !== "") {
      setNameLogo(component.nameLogo);
    } else {
      setNameLogo("Nombre del hospital");
    }
  }, [component.nameLogo]);

  useEffect(() => {
    if (component.titleName !== undefined && component.titleName !== "") {
      setTitleName(component.titleName);
    } else {
      setTitleName("Nuevo Formulario");
    }
  }, [component.titleName]);

  const handleSave = (updates) => {
    onUpdate(updates);
    setIsEditing(false);
  };

  const handleLogoClick = () => {
    fileInputRef.current?.click();
  };
  const handleLogoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (ev) => {
        setLogoPreview(ev.target.result);
        onUpdate({ logo: ev.target.result });
      };
      reader.readAsDataURL(file);
    }
  };
  const handleBlurNameLogo = () => {
    setIsEditingHospital(false);
    onUpdate({ nameLogo });
  };
  const handleBlurTitleName = () => {
    setIsEditingTitle(false);
    onUpdate({ titleName });
  };
  // --- Fin handlers formHeader ---

  const handleEditLabel = () => {
    setLabelValue(component.label || "");
    setIsEditingLabel(true);
  };

  const handleLabelChange = (e) => {
    setLabelValue(e.target.value);
  };

  const handleLabelBlur = () => {
    onUpdate({ label: labelValue });
    setIsEditingLabel(false);
  };

  const handleLabelKeyDown = (e) => {
    if (e.key === "Enter") {
      handleLabelBlur();
    }
  };

  const renderComponent = () => {
    switch (component.type) {
      case "header":
        return <Header component={component} isEditing={isEditing} onSave={handleSave} mode={mode} />;

      case "section":
        return <Section component={component} isEditing={isEditing} onSave={handleSave} mode={mode} />;

      case "label":
        return (
          <Label
            component={component}
            isEditingLabel={isEditingLabel}
            labelValue={labelValue}
            onLabelChange={handleLabelChange}
            onLabelBlur={handleLabelBlur}
            onLabelKeyDown={handleLabelKeyDown}
            mode={mode}
          />
        );

      case "input":
        return (
          <Input
            component={component}
            isEditingLabel={isEditingLabel}
            labelValue={labelValue}
            onLabelChange={handleLabelChange}
            onLabelBlur={handleLabelBlur}
            onLabelKeyDown={handleLabelKeyDown}
            mode={mode}
            value={value}
            onChange={onChange}
            readOnly={readOnly}
          />
        );

      case "textArea":
        return (
          <TextArea
            component={component}
            isEditingLabel={isEditingLabel}
            labelValue={labelValue}
            onLabelChange={handleLabelChange}
            onLabelBlur={handleLabelBlur}
            onLabelKeyDown={handleLabelKeyDown}
            mode={mode}
            value={value}
            onChange={onChange}
            readOnly={readOnly}
          />
        );

      case "select":
        return (
          <SelectComponent
            component={component}
            isEditingLabel={isEditingLabel}
            labelValue={labelValue}
            onLabelChange={handleLabelChange}
            onLabelBlur={handleLabelBlur}
            onLabelKeyDown={handleLabelKeyDown}
            mode={mode}
            value={value}
            onChange={onChange}
            readOnly={readOnly}
          />
        );

      case "checklist":
        return (
          <Checklist
            component={component}
            isEditingLabel={isEditingLabel}
            labelValue={labelValue}
            onLabelChange={handleLabelChange}
            onLabelBlur={handleLabelBlur}
            onLabelKeyDown={handleLabelKeyDown}
            mode={mode}
            value={value}
            onChange={onChange}
            readOnly={readOnly}
          />
        );

      case "radiobutton":
        return (
          <RadioButton
            component={component}
            isEditingLabel={isEditingLabel}
            labelValue={labelValue}
            onLabelChange={handleLabelChange}
            onLabelBlur={handleLabelBlur}
            onLabelKeyDown={handleLabelKeyDown}
            mode={mode}
            value={value}
            onChange={onChange}
            readOnly={readOnly}
          />
        );

      case "button":
        return <ButtonComponent component={component} isEditing={isEditing} onSave={handleSave} mode={mode} />;

      case "divider":
        return <DividerComponent component={component} mode={mode} />;

      case "image":
        return (
          <Image
            component={component}
            imagePreview={component.imagePreview}
            onImageClick={component.onImageClick}
            isEditMode={mode === "edit"}
            // Props para modo respuesta
            value={value}
            onChange={onChange}
            readOnly={readOnly}
          />
        );

      case "formHeader":
        return (
          <FormHeader
            component={component}
            logoPreview={logoPreview}
            nameLogo={nameLogo}
            titleName={titleName}
            isEditingHospital={isEditingHospital}
            isEditingTitle={isEditingTitle}
            onLogoClick={handleLogoClick}
            onNameLogoChange={(e) => setNameLogo(e.target.value)}
            onNameLogoBlur={handleBlurNameLogo}
            onTitleNameChange={(e) => setTitleName(e.target.value)}
            onTitleNameBlur={handleBlurTitleName}
            onEditNameLogo={() => setIsEditingHospital(true)}
            onEditTitleName={() => setIsEditingTitle(true)}
            mode={mode}
          />
        );

      case "cells":
        return (
          <Cells
            component={component}
            onUpdate={onUpdate}
            isSelected={isSelected}
            mode={mode}
            value={value}
            onChange={onChange}
            readOnly={readOnly}
          />
        );

      default:
        return (
          <Box
            sx={{
              width: "100%",
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "text.secondary",
            }}
          >
            Componente no reconocido
          </Box>
        );
    }
  };

  return (
    <Box sx={{ position: "relative", width: "100%", height: "100%" }}>
      {renderComponent()}

      {/* Input file oculto para FormHeader */}
      {component.type === "formHeader" && (
        <input
          ref={fileInputRef}
          type="file"
          accept="image/*"
          style={{ display: "none" }}
          onChange={handleLogoChange}
        />
      )}

      {/* Controles de edición */}
      {isSelected && (
        <Paper
          sx={{
            position: "absolute",
            top: -20,
            right: -8,
            display: "flex",
            alignItems: "flex-end",
            gap: 0.5,
            bgcolor: "white",
            border: 1,
            borderColor: "grey.300",
            borderRadius: 1,
            boxShadow: 1,
            px: 1,
            py: 0.5,
          }}
        >
          {component.label !== undefined && (
            <IconButton
              onClick={handleEditLabel}
              size="small"
              sx={{ color: "primary.main", "&:hover": { bgcolor: "primary.50" } }}
            >
              <EditIcon sx={{ fontSize: 16 }} />
            </IconButton>
          )}
          <IconButton onClick={onDelete} size="small" sx={{ color: "error.main", "&:hover": { bgcolor: "error.50" } }}>
            <DeleteIcon sx={{ fontSize: 16 }} />
          </IconButton>
        </Paper>
      )}
    </Box>
  );
};

export default FormComponent;
